import axios from "axios";
import store from "store";
import { setSystemError } from "store/actions";
//import accessToken from "./jwt-token-access/accessToken";

// Initial loading is now handled by the request interceptor


//apply base url for axios
const API_URL = process.env.REACT_APP_BASEURL;

const axiosApi = axios.create({
  baseURL: API_URL,
});

axiosApi.interceptors.request.use((config) => {
  const tokenJson = localStorage.getItem('authUser');
  if (tokenJson) {
    try {
      const tokenData = JSON.parse(tokenJson);
      config.headers["Authorization"] = "Bearer " + tokenData.token;
    } catch (ex) {
      console.error("Error parsing authUser from localStorage", ex);
    }
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

axiosApi.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API call error:", error?.response?.status, error?.config?.url, error?.response?.data);
    if (error?.response?.status == 401) {
      console.warn("Unauthorized access - redirecting to logout");
      if (window.location.pathname !== "/login") {
        window.location.href = "/logout"
      }
    }

    return Promise.reject(error);
  }
);

export async function get(url, config = {}) {
  return await axiosApi
    .get(url, { ...config })
    .then((response) => response.data);
}



export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, data, { ...config })
    .then((response) => response.data)
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then((response) => response.data);
}
